<script setup>
// The Pandig "pand" (house) mark. Colour comes from the parent via currentColor;
// any class passed in falls through onto the root <svg>.
</script>

<template>
  <svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M32 7 57 29V57H7V29ZM26 57V44a6 6 0 0 1 12 0v13Z"
    />
  </svg>
</template>
